var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "chevron-left"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron-left_2",
    d: "M20.3606 13.0044L10.5925 3.57151C9.99662 2.99604 9.98004 2.04644 10.5555 1.45051C11.131 0.854594 12.0806 0.838019 12.6765 1.41349L23.4666 11.8334C23.5603 11.9238 23.6397 12.0236 23.7047 12.1297C24.1482 12.7258 24.0907 13.5729 23.542 14.1027L12.7519 24.5226C12.156 25.0981 11.2064 25.0815 10.6309 24.4856C10.0554 23.8897 10.072 22.9401 10.6679 22.3646L20.3606 13.0044Z",
    fill: "#94A6B8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1340_2175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 14,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "chevron-left_3",
    d: "M20.3606 13.0044L10.5925 3.57151C9.99662 2.99604 9.98004 2.04644 10.5555 1.45051C11.131 0.854594 12.0806 0.838019 12.6765 1.41349L23.4666 11.8334C23.5603 11.9238 23.6397 12.0236 23.7047 12.1297C24.1482 12.7258 24.0907 13.5729 23.542 14.1027L12.7519 24.5226C12.156 25.0981 11.2064 25.0815 10.6309 24.4856C10.0554 23.8897 10.072 22.9401 10.6679 22.3646L20.3606 13.0044Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1340_2175)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.9c1b8865c557bb37491fbe7096a8755b.svg";
export { ForwardRef as ReactComponent };